import axios from "axios";
import { ElNotification } from "element-plus";
export const billingService = axios.create({
  baseURL:
    process.env.VUE_APP_ENV == "production"
    // LIS-backend-v2-billing /charge/* (orderV2-enriched patientInvoice migrated
    // off the legacy LIS-accounting-wsgi /v1/accounting-frontend-service path).
    ? 'https://api.vibrant-wellness.com/v1/accounting/charge'
    : 'https://api.vibrant-wellness.com/v1/accounting/staging/charge'
    // Previous: /v1/accounting-frontend-service[/staging] → LIS-accounting-wsgi (Python).
    // Pre-previous: /lisapi/v1/lis/wsgi/accounting[/staging] → on-prem.
});

let notificationInstance = null;
let notFoundNotificationInstance = null;
let unauthorizedNotification = null;

billingService.interceptors.request.use(
  function (config) {
    const token = `Bearer ${localStorage.getItem("pnsToken")}`;
    if (token) config.headers["Authorization"] = token;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

billingService.interceptors.response.use(
  (response) => {
    if (response.status !== 200 && response.status !== 201) {
      if (!notificationInstance) {
        notificationInstance = ElNotification({
          title: "Failed",
          type: "error",
          customClass: "errorNotification",
          message: response.message,
          duration: 0,
          onClose: () => {
            notificationInstance = null;
          },
        });
      }
      return Promise.reject("error");
    } else {
      return response;
    }
  },
  (error) => {
    const { status } = error.response;
    if (status === 404) {
      if (!notFoundNotificationInstance) {
        notFoundNotificationInstance = ElNotification({
          title: "Failed",
          message: "Not Found",
          customClass: "errorNotification",
          type: "error",
          duration: 3500,
          onClose: () => {
            notFoundNotificationInstance = null;
          },
        });
      }
    } else if (status === 401) {
      if (!unauthorizedNotification) {
        unauthorizedNotification = ElNotification({
          title: "Failed",
          message: "Unauthorized",
          customClass: "errorNotification",
          type: "error",
          duration: 3500,
          onClose: () => {
            unauthorizedNotification = null;
          },
        });
      }
    } else {
      const errorMessage = error.response.data.description;

      if (!notificationInstance) {
        notificationInstance = ElNotification({
          title: "Failed",
          message: errorMessage,
          customClass: "errorNotification",
          type: "error",
          duration: 3500,
          onClose: () => {
            notificationInstance = null;
          },
        });
      }
    }
    return Promise.reject(error);
  }
);

export default billingService;
